import { handleAPIError } from "handlers/setters";
import { generateQueryString } from "utils/query";
import { instanceWithRetry } from "actions/axiosInstance";
import get from "lodash/get";
import Toaster from "components/Toaster";
import { getLocaleString } from "utils/localization/locale";

export const getSavedSearchList = (params) => instanceWithRetry
    .get(`saved_search${generateQueryString(params)}`)
    .catch((e) => handleAPIError(e));

export const getSavedSearch = (params) => instanceWithRetry
    .get(`saved_search${generateQueryString(params)}`)
    .catch((e) => handleAPIError(e));

export const saveSearch = (data) =>
  instanceWithRetry[get(data, "id", "") ? "put" : "post"](
    `saved_search${generateQueryString({
      mutate: 1,
      id: get(data, "id", ""),
    })}`,
    data
  ).catch((e) => {
    if (get(e, "status", "") === 409) {
      Toaster(
        getLocaleString(
          "saved_search.saved_search_already_created",
          "Saved search is already created with this name, Please try different name"
        ),
        "error"
      );
    }
    if ([400, 500].includes(get(e, "status", ""))) {
      Toaster(
        getLocaleString(
          "saved_search.unable_to_create_saved_search",
          "Unable to create saved search"
        ),
        "error"
      );
    }
    handleAPIError(e);
  });

export const editSavedSearch = (id, params) => instanceWithRetry
    .post(`saved_search${generateQueryString(id)}`, { params })
    .catch((e) => handleAPIError(e));

export const deleteSavedSearch = (id) => instanceWithRetry
    .delete(`saved_search${generateQueryString(id)}`)
    .catch((e) => handleAPIError(e));

export function getUsersList() {
  return instanceWithRetry.get("client/user");
}

export const getScheduledSearch = (params) => instanceWithRetry
    .get(`saved_search/schedule_saved_search${generateQueryString(params)}`)
    .catch((e) => handleAPIError(e));

export const scheduleSavedSearch = (data) => instanceWithRetry[get(data, "id", "") ? "put" : "post"](
    `saved_search/schedule_saved_search${generateQueryString({
      mutate: 1,
      id: get(data, "id", ""),
    })}`,
    data
  ).catch((e) => {
    if ([400, 500].includes(get(e, "status", ""))) {
      Toaster("Unable to schedule saved search report", "error");
    }
    handleAPIError(e);
  });

export const deleteScheduledSearch = (id) => instanceWithRetry
    .delete(`saved_search/schedule_saved_search${generateQueryString(id)}`)
    .catch((e) => handleAPIError(e));
